// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState, useMemo } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import { Stack, useMediaQuery, useTheme } from "@mui/material";
import { Table } from "../molecules";
import { GridColDef, GridPaginationModel } from "@mui/x-data-grid";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { useGetBankPaymentDetail } from "../../hooks";
import { default as dayjs } from "dayjs";
import { downloadExcel } from "../../util/downloadExcel";
import { useSetSnackBar } from "../../store/Snackbar.state";
export function BankPaymentModal({ transaction, isOpen, handleClose }) {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [tableData, setTableData] = useState([]);
  const [queryOptions, setQueryOptions] = React.useState({});
  const setSnackbar = useSetSnackBar();
  const {
    mutate: GetBankPaymentDetail,
    isLoading: isGetBankPaymentDetailLoading,
  } = useGetBankPaymentDetail();
  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 10,
  });

  const handleChangePagination = (model: GridPaginationModel) => {
    setPaginationModel(model);
    const req: GetMerchantPaymenDetailtRequest = {
      date: getValues("date")
        ? dayjs(getValues("date")).format("YYYY-MM-DD")
        : "",
      bankCode: getValues("bankCode")?getValues("bankCode"):"",
      orderByDesc: true,
      status: getValues("status"),
      size: paginationModel.pageSize,
      page: paginationModel.page,
      orderBy: "CreateDate",
      ...getQueryParams(queryOptions),
    };

    GetBankPaymentDetail(req, {
      onSuccess: (data) => {
        if (data.isSuccess) {
          setTableData(data.data);
          setSnackbar({
            severity: "success",
            isOpen: true,
            description: data.message,
          });
        } else {
          setSnackbar({
            severity: "error",
            description: data.message,
            isOpen: true,
          });
        }
      },
      onError: () => {
        setSnackbar({
          severity: "error",
          description: "İşlem sırasında bir hata oluştu",
          isOpen: true,
        });
      },
    });
  };
  const columns: GridColDef[] = useMemo(() => {
    return [
      { field: "merchantId", headerName: "Üyer İşyeri Numarası", width: 150 },
      { field: "merchantName", headerName: "Üye İşyeri Adı", width: 200 },
      { field: "maskedPan", headerName: "Kart Numarası", width: 200 },
      { field: "orderId", headerName: "Sipariş Numarası", width: 250 },
      { field: "bankName", headerName: "Banka Adı", width: 300 },
      { field: "bankCode", headerName: "Banka Kodu", width: 180 },
      { field: "status", headerName: "İşlem Durumu", width: 150 },
      {
        field: "transactionDate",
        headerName: "İşlem Tarihi",
        width: 200,
        valueFormatter: (params: GridValueFormatterParams<string>) => {
          const date = new Date(params.value);
          const day = date.getDate().toString().padStart(2, "0");
          const month = (date.getMonth() + 1).toString().padStart(2, "0"); // +1 çünkü aylar 0'dan başlar
          const year = date.getFullYear();

          return `${day}-${month}-${year}`;
        },
      },
      { field: "installmentCount", headerName: "Taksit Sayısı", width: 180 },
      { field: "txnType", headerName: "İşlem Tipi", width: 180 },
      {
        field: "totalAmount",
        headerName: "Toplam Tutar",
        width: 200,
        type: 'decimal',
        valueFormatter: (params: GridValueFormatterParams<number>) =>
          `${params.value} TL`,
      },
      {
        field: "amount",
        headerName: "Tutar",
        width: 200,
        type: 'decimal',
        valueFormatter: (params: GridValueFormatterParams<number>) =>
          `${params.value} TL`,
      },
      { field: "currency", headerName: "Para Birimi Kodu", width: 150 },

      {
        field: "cardHolderName",
        headerName: "İşlem Yapılan Kart Bilgisi",
        width: 200,
      },

      { field: "bankblocked", headerName: "Banka Blokesi", width: 180,
      renderCell: (params) => {
        if (params.value == null || params.value === " ") {
          return ""; 
        }
        return params.value ? "Evet" : "Hayır"; 
      }, },
      { field: "bankblockedday", headerName: "Banka Bloke Günü", width: 200 },
      {
        field: "bankCommissionAmount",
        headerName: "Banka Komisyon Tutarı",
        width: 200,
        type: 'decimal',
        valueFormatter: (params: GridValueFormatterParams<number>) =>
          `${params.value} TL`,
      },
      {
        field: "bankAmount",
        headerName: "Banka Tutarı",
        width: 200,
        type: 'decimal',
        valueFormatter: (params: GridValueFormatterParams<number>) =>
          `${params.value} TL`,
      },
      {
        field: "merchantblocked",
        headerName: "İşyeri Blokesi",
        width: 200,
        renderCell: (params) => {
          if (params.value == null || params.value === " ") {
            return ""; 
          }
          return params.value ? "Evet" : "Hayır"; 
        },
      },
      {
        field: "merchantblockedday",
        headerName: "Üye İşyeri Bloke Günü",
        width: 200,
      },
      {
        field: "merchantCommisionAmount",
        headerName: "Üye İşyeri Komisyon Tutarı",
        width: 200,
        type: 'decimal',
        valueFormatter: (params: GridValueFormatterParams<number>) =>
          `${params.value} TL`,
      },
      {
        field: "merchantAmount",
        headerName: "Üye İşyeri Tutarı",
        width: 200,
        type: 'decimal',
        valueFormatter: (params: GridValueFormatterParams<number>) =>
          `${params.value} TL`,
      },
      {
        field: "customerCommissionAmount",
        headerName: "Müşteri Komisyon Tutarı",
        width: 200,
        type: 'decimal',
        valueFormatter: (params: GridValueFormatterParams<number>) =>
          `${params.value} TL`,
      },
      {
        field: "revenue",
        headerName: "AHL Pay Kar",
        width: 200,
        type: 'decimal',
        valueFormatter: (params: GridValueFormatterParams<number>) =>
          `${params.value} TL`,
      },
      { field: "cardType", headerName: "Kart Tipi", width: 180 },
      { field: "authCode", headerName: "Otorizasyon Kodu", width: 180 },
      {
        field: "endOfDayDate",
        headerName: "Gün Sonu Tarih",
        width: 200,
        valueFormatter: (params: GridValueFormatterParams<string>) => {
          const date = new Date(params.value);
          const day = date.getDate().toString().padStart(2, "0");
          const month = (date.getMonth() + 1).toString().padStart(2, "0"); // +1 çünkü aylar 0'dan başlar
          const year = date.getFullYear();

          return `${day}-${month}-${year}`;
        },
      },

      {
        field: "originalOrderId",
        headerName: "Orjinal Sipariş ID",
        width: 250,
      },
      {
        field: "paymentFlag",
        headerName: "Ödeme Yapıldı Mı?",
        width: 180,
        renderCell: (params) => {
          if (params.value == null || params.value === " ") {
            return ""; 
          }
          return params.value ? "Evet" : "Hayır"; 
        },
      }
      
    ];
  }, []);


  useEffect(() => {
    if (isOpen && transaction) {
      const requestPayload = {
        bankCode: transaction.bankCode, date: transaction.endOfDayDate,
        ...getQueryParams(queryOptions),
      };
      
    if (queryOptions?.field && queryOptions?.value !== undefined) {
      requestPayload[queryOptions.field] = queryOptions.value;
    }
      GetBankPaymentDetail(
    requestPayload,
        {
          onSuccess: (data) => {
            if (data.isSuccess) {
              setTableData(data.data);
              setSnackbar({
                severity: "success",
                isOpen: true,
                description: data.message,
              });
            } else {
              setSnackbar({
                severity: "error",
                description: data.message,
                isOpen: true,
              });
            }
          },
          onError: () => {
            setSnackbar({
              severity: "error",
              description: "İşlem sırasında bir hata oluştu",
              isOpen: true,
            });
          },
        }
      );
    }
  }, [isOpen, transaction,queryOptions]);

  const onSave = () => {
    const requestPayload = {
      size: -1,
      page: 0,
      orderBy: "CreateDate",
      orderByDesc: true,
      bankCode: transaction?.bankCode,
      date: dayjs(transaction?.endOfDayDate).format("YYYY-MM-DD"),
      ...getQueryParams(queryOptions),
    }
    if (queryOptions?.field && queryOptions?.value !== undefined) {
      requestPayload[queryOptions.field] = queryOptions.value;
    }
    GetBankPaymentDetail(
      requestPayload,
      {
        onSuccess: (data) => {
          if (data.isSuccess && data.data) {
            function fieldValue(data) {        
              return data.map((item) => {
                return {
                  "Üyer İşyeri Numarası": item?.merchantId,
                  "Üye İşyeri Adı": item?.merchantName,
                  "Kart Numarası": item?.maskedPan,
                  "Sipariş Numarası": item?.orderId,
                  "Banka Adı": item?.bankName,
                  "Banka Kodu": item?.bankCode,
                  "İşlem Durumu": item?.status,
                  "İşlem Tarihi": item?.transactionDate, 
                  "Taksit Sayısı": item?.installmentCount,
                  "İşlem Tipi": item?.txnType,
                  "Toplam Tutar": item?.totalAmount ,
                  "Tutar": item?.amount ,
                  "Para Birimi Kodu": item?.currency,
                  "İşlem Yapılan Kart Bilgisi": item?.cardHolderName,
                  "Banka Blokesi": item?.bankblocked !== null ? (item.bankblocked ? "Evet" : "Hayır") : " ",
                  "Banka Bloke Günü": item?.bankblockedday,
                  "Banka Komisyon Tutarı": item?.bankCommissionAmount,
                  "Banka Tutarı": item?.bankAmount ,
                  "İşyeri Blokesi": item?.merchantblocked !== null ? (item.merchantblocked ? "Evet" : "Hayır") : " ",
                  "İşyeri Bloke Gün Sayısı": item?.merchantblockedday,
                  "Üye İşyeri Komisyon Tutarı": item?.merchantCommisionAmount,
                  "Üye İşyeri Tutarı": item?.merchantAmount ,
                  "Müşteri Komisyon Tutarı": item?.customerCommissionAmount ,
                  "AHL Pay Kar": item?.revenue ,
                  "Kart Tipi": item?.cardType,
                  "Otorizasyon Kodu": item?.authCode,
                  "Gün Sonu Tarih": item?.endOfDayDate, 
                  "Orjinal Sipariş ID": item?.originalOrderId,
                  "Ödeme Yapıldı Mı?": item?.paymentFlag !== null ? (item.paymentFlag ? "Evet" : "Hayır") : " "
                };
              });
            }
            const refactoredData = fieldValue(data?.data);
            downloadExcel(
              refactoredData || [],"Banka Hak Ediş Raporları Detay"
            );
          } else {
            setSnackbar({
              severity: "error",
              description: data.message,
              isOpen: true,
            });
          }
        },
        onError: () => {
          console.log(error);
          setSnackbar({
            severity: "error",
            description: "İşlem sırasında bir hata oluştu",
            isOpen: true,
          });
        },
      }
    );
  };
  const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func.apply(null, args);
      }, delay);
    };
  };

  const getQueryParams = (filters) => {
    const queryParams = {};

    for (let key in filters) {
      if (filters[key]?.toString()?.length >= 1) {
        queryParams[key] = filters[key];
      }
    }

    return queryParams;
  };

  const handleFilterChange = debounce((filters) => {
    if (filters.clearFilter) {
      return setQueryOptions({});
    }
  
    const queryParams = getQueryParams(filters);
  
    const allValuesAtLeastThreeChars = Object.values(queryParams).every((value) => value?.toString().length >= 3);
    const atLeastOneValueThreeChars = Object.values(queryParams).some((value) => value?.toString().length >= 3);
    
    const previousKeysLength = Object.keys(previousQueryParams.current).length;
    const currentKeysLength = Object.keys(queryParams).length;
  
    // Eğer queryParams bir önceki ile aynıysa işlem yapma
    if (JSON.stringify(previousQueryParams.current) === JSON.stringify(queryParams)) {
      return;
    }
  
    if ((allValuesAtLeastThreeChars || (atLeastOneValueThreeChars && previousKeysLength > currentKeysLength))) {
      setQueryOptions(queryParams);
    }
  
    // Son olarak, mevcut queryParams değerini bir önceki değer olarak set edin
    previousQueryParams.current = queryParams;
  
  }, 500);
  const hasActiveFilters = Object?.keys(queryOptions)?.length > 0;
  // Komponent içerisinde
  const previousQueryParams = React.useRef({});
  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: isDesktop ? 1300 : isSmallScreen ? "90%" : "70%",
          maxHeight: '90vh',  // eklenen satır
          maxWidth: '90vw',  // eklenen satır
          overflow: 'auto',  // eklenen satır
          bgcolor: "background.paper",
          border: "2px solid #2196f3",
          boxShadow: 24,
          p: 4,
          display: "relative",
        }}
      >
        <h2 id="modal-modal-title">Banka Hak Ediş Raporları Detay</h2>

        <Stack
          justifyContent="center"
          sx={{ width: 1, height: 600, flexGrow: 1, overflowX: 'auto' }}
        >
          {tableData && (
            <>
                <Table
                 handleFilterChange={handleFilterChange}
                 columnVisibilityConfigKey="bankPaymentModalColumnVisibilityKey"
                  paginationModel={paginationModel}
                  hasActiveFilters={hasActiveFilters}
                  onPaginationModelChange={handleChangePagination}
                  paginationMode="server"
                  rowCount={tableData.totalItems}
                  className="myTable"
                  // rowCount={tableData?.length}
                  sx={{
                    width: isDesktop ? 1240 : "auto",
                    height: isDesktop ? "600px" : "auto",
                  }}
                  isRowSelectable={() => false}
                  // disableColumnMenu
                  rows={tableData}
                  // getRowId={(row) => row.merchantId}
                  // rows={tableData || []}
                  autoHeight={!isDesktop}
                  columns={columns}
                  exportFileName="Banka Hak Ediş Raporları"
                  // getRowId={(row) => row.merchantId}
                  onSave={() => onSave()}
                />
            </>
          )}
        </Stack>
        {/* <Button onClick={handleClose}>Close</Button> */}
        <IconButton
          sx={{
            position: "absolute",
            top: 2,
            right: 2,
          }}
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>
      </Box>
    </Modal>
  );
}
